import { apiConfig } from '../helpers';
import { authHeader } from '../helpers';
import axios from 'axios';

export const reportService = {
    
    getAll,
    getReport,    
    generateReport,
    downloadReport
};
function generateReport(data)
{
    return axios.post('/api/services/app/Report/GenerateReport',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function getAll()
{
    return axios.get('/api/services/app/Report/GetReportList', {        
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function getReport(id)
{
    return axios.get('/api/services/app/Report/GetReport', {
        params: {            
          id: id
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function downloadReport(token)
{
    return axios({
        url: '/file/DownloadReportFile',
        params: { token: token},
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        responseType: 'blob',
        method: 'GET'
    })
}